
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
class $9ebc86e59e467e73$export$c672d870a5fac9b {
    width = null;
    height = null;
    canvas = null;
    ctx = null;
    constructor(){
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
    }
    getCanvasSize() {
        return {
            width: this.width,
            height: this.height
        };
    }
    getCanvas() {
        return this.canvas;
    }
    getCanvasContext() {
        return this.ctx;
    }
    setCanvasSize(width, height) {
        this.width = width;
        this.height = height;
        const pixelRate = window.devicePixelRatio || 1;
        this.canvas.style.width = width + 'px';
        this.canvas.style.height = height + 'px';
        this.canvas.width = width * pixelRate;
        this.canvas.height = height * pixelRate;
        this.ctx.scale(pixelRate, pixelRate);
    }
}


class $124834f2d4b25abd$export$f3f3f6c0124f08de {
    constructor({ gameCanvas: gameCanvas, renderEngine: renderEngine }){
        this.gameCanvas = gameCanvas;
        this.renderEngine = renderEngine;
    }
    startGame() {
        window.requestAnimationFrame(()=>{
            this.renderEngine.render({
                gameCanvas: this.gameCanvas
            });
        });
    }
}


class $5972a2952a676e7e$export$a00812b7fa77a768 {
    gameObjectsList = [];
    addGameObject({ gameObject: gameObject }) {
        const isGameObjectAlreadyAdded = this.gameObjectsList.find(({ name: name })=>name === gameObject.name);
        if (isGameObjectAlreadyAdded) throw new Error(`Game object with name: ${gameObject.name} is} already added`);
        this.gameObjectsList.push(gameObject);
    }
    removeGameObject({ gameObject: gameObject }) {
        this.gameObjectsList = this.gameObjectsList.filter(({ name: name })=>name !== gameObject.name);
    }
    clean({ gameCanvas: gameCanvas }) {
        gameCanvas.getCanvasContext().clearRect(0, 0, gameCanvas.getCanvas().width, gameCanvas.getCanvas().height);
    }
    update({ gameCanvas: gameCanvas }) {
        this.gameObjectsList.forEach((gameObject)=>{
            gameObject.update({
                gameCanvas: gameCanvas
            });
        });
    }
    render({ gameCanvas: gameCanvas }) {
        this.clean({
            gameCanvas: gameCanvas
        });
        this.update({
            gameCanvas: gameCanvas
        });
        this.gameObjectsList.forEach((gameObject)=>{
            gameObject.render({
                gameCanvas: gameCanvas
            });
        });
        window.requestAnimationFrame(()=>{
            this.render({
                gameCanvas: gameCanvas
            });
        });
    }
}


const $037a87e36871af8f$export$192d610b0b7719f4 = {
    WIDTH: 800,
    HEIGHT: 600,
    PLAYER_GAP_FROM_WALL: 54
};
const $037a87e36871af8f$export$56d196d2844d1ca1 = {
    PRIMARY: '#9b4646',
    PRIMARY_DARK: '#893737',
    HIGHLIGHT: '#d9dd2a',
    LIGHT: '#ffffff',
    DARK: '#000000'
};
const $037a87e36871af8f$export$826128ff895ed268 = {
    PRIMARY: 'Rubik Mono One, monospace'
};
const $037a87e36871af8f$export$5752360ebe58630f = {
    RADIUS: 10
};
const $037a87e36871af8f$export$96d2c50407ad80f7 = {
    USER: 'user',
    MACHINE: 'machine'
};




class $dd536d7a2f7bfeb0$export$d4c35b16058796c2 {
    askedMachineToMove = false;
    constructor({ pongBall: pongBall, playerObject: playerObject }){
        this.pongBall = pongBall;
        this.playerObject = playerObject;
    }
    move() {
        // ball is moving left
        if (this.pongBall.directionX < 0) {
            this.askedMachineToMove = false;
            return;
        }
        if (this.askedMachineToMove) return;
        if (this.pongBall.x < (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH / 2) return; // ball is not on the middle of screen
        const futurePointY = this.getWhereBallWillHitY();
        this.moveMachine({
            yTarget: futurePointY
        });
    }
    moveMachine({ yTarget: yTarget }) {
        this.playerObject.goTo({
            yTarget: yTarget
        });
        this.askedMachineToMove = true;
    }
    getWhereBallWillHitY() {
        const amountBallMovePerFrame = this.pongBall.speed * this.pongBall.directionX;
        const [ballPositionX, ballPositionY] = [
            this.pongBall.x,
            this.pongBall.y
        ];
        const futurePointWallToCalculateImpact = (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH - (0, $037a87e36871af8f$export$192d610b0b7719f4).PLAYER_GAP_FROM_WALL;
        const distanceToFuturePointWall = futurePointWallToCalculateImpact - ballPositionX;
        const framesNeededToMoveToFuturePoint = distanceToFuturePointWall / amountBallMovePerFrame;
        const angleBallIsMoving = this.pongBall.directionY;
        const whereIsTheFuturePointY = ballPositionY + angleBallIsMoving * this.pongBall.speed * framesNeededToMoveToFuturePoint;
        let finalBallPredictedPositionY = whereIsTheFuturePointY;
        if (whereIsTheFuturePointY > (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT) {
            const diff = finalBallPredictedPositionY - (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT;
            finalBallPredictedPositionY = (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT - diff;
        }
        if (whereIsTheFuturePointY < 0) finalBallPredictedPositionY *= -1;
        return finalBallPredictedPositionY;
    }
}


const $a2d20170fd2d0ec6$export$c0b5bd72bdc39888 = {
    STATIC: 'static',
    DYNAMIC: 'dynamic'
};
class $a2d20170fd2d0ec6$var$GameObjectEvent {
    events = {
        mousemove: [],
        click: [],
        keyup: [],
        keydown: []
    };
    onEvent({ name: name, callback: callback }) {
        this.events[name].push(callback);
    }
    watchForEvents({ DOMElement: DOMElement = window }) {
        const allEvents = Object.keys(this.events);
        allEvents.forEach((eventName)=>{
            DOMElement.addEventListener(eventName, (event)=>{
                const rangeX = {
                    start: this.x,
                    end: this.x + this.width
                };
                const rangeY = {
                    start: this.y,
                    end: this.y + this.height
                };
                const isInsideXArea = event.offsetX >= rangeX.start && event.offsetX <= rangeX.end;
                const isInsideYArea = event.offsetY >= rangeY.start && event.offsetY <= rangeY.end;
                const isInsideGameObjectArea = isInsideXArea && isInsideYArea;
                this.events[eventName].forEach((callback)=>{
                    callback({
                        isInsideGameObjectArea: isInsideGameObjectArea,
                        rawEvent: event
                    });
                });
            });
        });
    }
}
class $a2d20170fd2d0ec6$export$434da80b31429dcb extends $a2d20170fd2d0ec6$var$GameObjectEvent {
    name = null;
    type = $a2d20170fd2d0ec6$export$c0b5bd72bdc39888.DYNAMIC;
    width = null;
    height = null;
    x = 0;
    y = 0;
    collision = {
        isCollinding: false
    };
    _innerCollisionArea = null;
    constructor({ name: name }){
        super();
        if (typeof name !== 'string') throw new Error('Name is required to create a game object');
        this.name = name;
    }
    setInnerColissionArea({ x: x, y: y, width: width, height: height }) {
        this._innerCollisionArea = {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    getInnerCollisionArea() {
        if (!this._innerCollisionArea) {
            if (this.width != null && this.height != null) return {
                x: this.x,
                y: this.y,
                width: this.width,
                height: this.height
            };
            return null;
        }
        const x = this.x + this._innerCollisionArea.x;
        const y = this.y + this._innerCollisionArea.y;
        const width = this._innerCollisionArea.width;
        const height = this._innerCollisionArea.height;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
    setCoordinates({ x: x, y: y }) {
        this.x = x || this.x;
        this.y = y || this.y;
    }
    setSizes({ width: width, height: height }) {
        this.width = width || this.width;
        this.height = height || this.height;
    }
    update() {
        if (this.type === 'dynamic') throw new Error(`Method update not implemented on: ${this.name}. If you want to create a static game object set type to "static" on your class`);
    }
    render() {
        throw new Error(`Method render not implemented on: ${this.name}`);
    }
    hasCollidedWith({ gameObject: gameObject }) {
        if (gameObject.getInnerCollisionArea() == null || this.getInnerCollisionArea() == null) throw new Error(`Game Object ${gameObject?.name == null ? gameObject.name : this?.name} has no innerColissionArea.`);
        const thisObjCollisionArea = this.getInnerCollisionArea();
        const gameObjCollisionArea = gameObject.getInnerCollisionArea();
        const collidedOnX = thisObjCollisionArea.x + thisObjCollisionArea.width >= gameObjCollisionArea.x && thisObjCollisionArea.x <= gameObjCollisionArea.x + gameObjCollisionArea.width;
        const collidedOnY = thisObjCollisionArea.y <= gameObjCollisionArea.y + gameObjCollisionArea.height && gameObjCollisionArea.y <= thisObjCollisionArea.y + thisObjCollisionArea.height;
        const collisionDetected = collidedOnX && collidedOnY;
        let collided = false;
        if (collisionDetected && this.collision.isCollinding) collided = false;
        if (!collisionDetected && this.collision.isCollinding) {
            collided = false;
            this.collision.isCollinding = false;
        }
        if (collisionDetected && !this.collision.isCollinding) {
            collided = true;
            this.collision.isCollinding = true;
        }
        const whereCollidedOnThisObj = collided ? {
            x: gameObjCollisionArea.x - thisObjCollisionArea.x,
            y: gameObjCollisionArea.y - thisObjCollisionArea.y
        } : null;
        console.log({
            whereCollidedOnThisObj: whereCollidedOnThisObj
        });
        return {
            collided: collided,
            isCollinding: this.collision.isCollinding,
            whereCollided: whereCollidedOnThisObj
        };
    }
}
class $a2d20170fd2d0ec6$export$d0720a2a928b95c8 extends $a2d20170fd2d0ec6$export$434da80b31429dcb {
    type = $a2d20170fd2d0ec6$export$c0b5bd72bdc39888.STATIC;
}



const $94b9b361231b1762$var$getXDirection = ()=>{
    return -1;
};
const $94b9b361231b1762$var$getYDirection = ()=>{
    return Math.random();
};
const $94b9b361231b1762$var$INITIAL_SPEED = 4;
class $94b9b361231b1762$export$b3460cf0983d8f2 extends (0, $a2d20170fd2d0ec6$export$434da80b31429dcb) {
    type = (0, $a2d20170fd2d0ec6$export$c0b5bd72bdc39888).DYNAMIC;
    x = (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH / 2 - (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS;
    y = (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT / 2 - (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS;
    speed = $94b9b361231b1762$var$INITIAL_SPEED;
    directionY = $94b9b361231b1762$var$getYDirection();
    directionX = $94b9b361231b1762$var$getXDirection();
    _onUpdateCallbacks = [];
    _reverseDirectionWhenHitWall() {
        const hasHitGround = this.y >= (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT;
        const hasHitCelling = this.y <= 0;
        if (hasHitGround || hasHitCelling) this.directionY *= -1;
    }
    _runOnUpdateCallbacks() {
        this._onUpdateCallbacks.forEach((callaback)=>callaback());
    }
    onUpdate(callback) {
        this._onUpdateCallbacks.push(callback);
    }
    // yPlayerHitRatio: A number between 0 and 1
    reverseDirectionWith({ yPlayerHitRatio: yPlayerHitRatio }) {
        this.directionX = this.directionX * -1;
        this.directionY = this.directionY > 0 ? yPlayerHitRatio : yPlayerHitRatio * -1;
    }
    reset() {
        this.x = (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH / 2 - (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS;
        this.y = (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT / 2 - (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS;
        this.directionY = $94b9b361231b1762$var$getYDirection();
        this.directionX = $94b9b361231b1762$var$getXDirection();
        this.speed = $94b9b361231b1762$var$INITIAL_SPEED;
    }
    incrementSpeed() {
        this.speed *= 1.04 // percentage increase
        ;
    }
    update() {
        this.y = this.y + this.speed * this.directionY;
        this.x = this.x + this.speed * this.directionX;
        this._reverseDirectionWhenHitWall();
        this._runOnUpdateCallbacks();
    }
    render({ gameCanvas: gameCanvas }) {
        const ctx = gameCanvas.getCanvasContext();
        ctx.fillStyle = (0, $037a87e36871af8f$export$56d196d2844d1ca1).LIGHT;
        ctx.beginPath();
        ctx.arc(this.x, this.y, (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS, 0, 2 * Math.PI);
        ctx.fill();
    }
}




class $a3a8827c3acf94ee$export$118d5a8ab19867f9 extends (0, $a2d20170fd2d0ec6$export$434da80b31429dcb) {
    type = (0, $a2d20170fd2d0ec6$export$c0b5bd72bdc39888).DYNAMIC;
    width = 15;
    height = 80;
    moveSpeed = 8;
    moveDirection = 0;
    isMoving = false;
    _autoMoveTargetY = null;
    beginMove(direction) {
        if (direction === 'up') this.moveDirection = -1;
        else this.moveDirection = 1;
        this.isMoving = true;
    }
    stopMove() {
        this.moveDirection = 0;
        this.isMoving = false;
    }
    moveUp() {
        const canMoveUp = this.y - this.moveSpeed >= 0;
        if (canMoveUp) this.y -= this.moveSpeed;
    }
    moveDown() {
        const canMoveDown = this.y + this.moveSpeed + this.height <= (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT;
        if (canMoveDown) this.y += this.moveSpeed;
    }
    goTo({ yTarget: yTarget }) {
        this._autoMoveTargetY = yTarget;
        if (yTarget > this.y) this.beginMove('down');
        if (yTarget < this.y) this.beginMove('up');
    }
    isBetweenYTarget() {
        if (this._autoMoveTargetY === null) return false;
        const rangeSize = this.height;
        const middlePoint = this.y + rangeSize / 2;
        const rangeMin = this._autoMoveTargetY - rangeSize / 4;
        const rangeMax = this._autoMoveTargetY + rangeSize / 4;
        return middlePoint > rangeMin && middlePoint < rangeMax;
    }
    update() {
        if (this.isMoving) {
            if (this.moveDirection === 1) this.moveDown();
            if (this.moveDirection === -1) this.moveUp();
            if (this.isBetweenYTarget()) {
                this.stopMove();
                this._autoMoveTargetY = null;
            }
        }
    }
    render({ gameCanvas: gameCanvas }) {
        const ctx = gameCanvas.getCanvasContext();
        ctx.fillStyle = (0, $037a87e36871af8f$export$56d196d2844d1ca1).HIGHLIGHT;
        ctx.fillRect(this.x, this.y, this.width, this.height);
    }
}




class $75565a4491b520f8$export$7cf06b9e7c194b2d extends (0, $a2d20170fd2d0ec6$export$434da80b31429dcb) {
    type = (0, $a2d20170fd2d0ec6$export$c0b5bd72bdc39888).STATIC;
    width = 10;
    height = (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT * 2 // increment heignt to catch offscreen colissions
    ;
    render({ gameCanvas: gameCanvas }) {
    // const ctx = gameCanvas.getCanvasContext()
    // ctx.fillStyle = COLORS.HIGHLIGHT
    // ctx.fillRect(this.x, this.y, this.width, this.height)
    }
}




class $59bb41db2b03bda2$export$5f986618f9ed165 extends (0, $a2d20170fd2d0ec6$export$434da80b31429dcb) {
    type = (0, $a2d20170fd2d0ec6$export$c0b5bd72bdc39888).STATIC;
    constructor({ text: text, fontSize: fontSize, fontColor: fontColor, textBaseline: textBaseline = 'top', textAlign: textAlign = 'left', ...params }){
        super(params);
        this.text = text;
        this.fontSize = fontSize;
        this.fontColor = fontColor;
        this.textBaseline = textBaseline;
        this.textAlign = textAlign;
    }
    setText(text) {
        this.text = text;
    }
    render({ gameCanvas: gameCanvas }) {
        const ctx = gameCanvas.getCanvasContext();
        ctx.fillStyle = this.fontColor;
        ctx.font = `${this.fontSize}px ${(0, $037a87e36871af8f$export$826128ff895ed268).PRIMARY}`;
        ctx.textBaseline = this.textBaseline;
        ctx.textAlign = this.textAlign;
        ctx.fillText(this.text, this.x, this.y);
        ctx.fill();
    }
}


class $2f29cb6e6111d04d$export$54e8baba0a5011af {
    player = new (0, $a3a8827c3acf94ee$export$118d5a8ab19867f9)({
        name: (0, $037a87e36871af8f$export$96d2c50407ad80f7).USER
    });
    machine = new (0, $a3a8827c3acf94ee$export$118d5a8ab19867f9)({
        name: (0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE
    });
    ball = new (0, $94b9b361231b1762$export$b3460cf0983d8f2)({
        name: 'ball'
    });
    playerScoreWall = new (0, $75565a4491b520f8$export$7cf06b9e7c194b2d)({
        name: 'player-score-wall'
    });
    machineScoreWall = new (0, $75565a4491b520f8$export$7cf06b9e7c194b2d)({
        name: 'machine-score-wall'
    });
    score = new (0, $59bb41db2b03bda2$export$5f986618f9ed165)({
        name: 'score',
        text: '0x0',
        fontSize: 72,
        fontColor: (0, $037a87e36871af8f$export$56d196d2844d1ca1).PRIMARY_DARK,
        textBaseline: 'middle',
        textAlign: 'center'
    });
    machineAI = null;
    _onScoreCallbacks = [];
    _onPlayerHitsBallCallbacks = [];
    show() {
        this.__setupInitialObjectLocation();
        this._setupObjectCollisions();
        this._setupEvents();
        this._setupMachinePlayerAI();
        this.ball.onUpdate(()=>{
            this._onBallCollision();
            this.machineAI.move();
        });
    }
    getScreenGameObjects() {
        return [
            this.score,
            this.player,
            this.machine,
            this.ball,
            this.playerScoreWall,
            this.machineScoreWall
        ];
    }
    updateScore(score) {
        this.score.setText(`${score[(0, $037a87e36871af8f$export$96d2c50407ad80f7).USER]}x${score[(0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE]}`);
    }
    onScore(callback) {
        this._onScoreCallbacks.push(callback);
    }
    onPlayerHitsBall(callback) {
        this._onPlayerHitsBallCallbacks.push(callback);
    }
    __setupInitialObjectLocation() {
        const halfHeight = (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT / 2 - this.player.height / 2;
        this.player.setCoordinates({
            x: (0, $037a87e36871af8f$export$192d610b0b7719f4).PLAYER_GAP_FROM_WALL,
            y: halfHeight
        });
        this.machine.setCoordinates({
            x: (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH - (0, $037a87e36871af8f$export$192d610b0b7719f4).PLAYER_GAP_FROM_WALL,
            y: halfHeight
        });
        this.score.setCoordinates({
            x: (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH / 2,
            y: (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT / 2
        });
        this.playerScoreWall.setCoordinates({
            y: this.playerScoreWall.height / 4 * -1,
            x: -this.playerScoreWall.width - (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * 2
        });
        this.machineScoreWall.setCoordinates({
            y: this.machineScoreWall.height / 4 * -1,
            x: (0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH + (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * 2
        });
    }
    _setupObjectCollisions() {
        this.player.setInnerColissionArea({
            y: 0,
            x: 13,
            width: 2,
            height: 80
        });
        this.machine.setInnerColissionArea({
            y: 0,
            x: 0,
            width: 2,
            height: 80
        });
        this.ball.setInnerColissionArea({
            x: (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * -1,
            y: (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * -1,
            width: (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * 2,
            height: (0, $037a87e36871af8f$export$5752360ebe58630f).RADIUS * 2
        });
    }
    _onPlayerHitsBall({ playerType: playerType, whereCollided: whereCollided }) {
        const fullPlayerHeight = this.player.height;
        const whereCollidedNormalized = whereCollided.y < 1 ? 1 : whereCollided.y > fullPlayerHeight ? fullPlayerHeight : whereCollided.y;
        const ratio = whereCollidedNormalized / fullPlayerHeight;
        const middlePointRatio = 0.5 // mean the ball hits exactly on center of player
        ;
        const finalRatio = Math.abs(ratio - middlePointRatio) * 2;
        if (playerType === (0, $037a87e36871af8f$export$96d2c50407ad80f7).USER) this.ball.reverseDirectionWith({
            yPlayerHitRatio: finalRatio
        });
        if (playerType === (0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE) this.ball.reverseDirectionWith({
            yPlayerHitRatio: finalRatio
        });
        this.ball.incrementSpeed();
        this._onPlayerHitsBallCallbacks.forEach((callback)=>{
            callback({
                playerType: playerType
            });
        });
    }
    _onBallCollision() {
        const { collided: collidedWithPlayer, whereCollided: whereCollidedWithPlayer } = this.player.hasCollidedWith({
            gameObject: this.ball
        });
        if (collidedWithPlayer) this._onPlayerHitsBall({
            playerType: (0, $037a87e36871af8f$export$96d2c50407ad80f7).USER,
            whereCollided: whereCollidedWithPlayer
        });
        const { collided: collidedWithMachine, whereCollided: whereCollidedWithMachine } = this.machine.hasCollidedWith({
            gameObject: this.ball
        });
        if (collidedWithMachine) this._onPlayerHitsBall({
            playerType: (0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE,
            whereCollided: whereCollidedWithMachine
        });
        const { collided: collidedWithPlayerWall } = this.playerScoreWall.hasCollidedWith({
            gameObject: this.ball
        });
        if (collidedWithPlayerWall) this._confirmScore({
            playerType: (0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE
        });
        const { collided: collidedWithMachineWall } = this.machineScoreWall.hasCollidedWith({
            gameObject: this.ball
        });
        if (collidedWithMachineWall) this._confirmScore({
            playerType: (0, $037a87e36871af8f$export$96d2c50407ad80f7).USER
        });
    }
    _confirmScore({ playerType: playerType }) {
        this._relaunchBall();
        this._onScoreCallbacks.forEach((callback)=>{
            callback({
                playerType: playerType
            });
        });
    }
    _relaunchBall() {
        this.ball.reset();
    }
    _setupEvents() {
        this.player.onEvent({
            name: 'keydown',
            callback: ({ rawEvent: rawEvent })=>{
                if (rawEvent.code === 'ArrowUp') this.player.beginMove('up');
                if (rawEvent.code === 'ArrowDown') this.player.beginMove('down');
            }
        });
        this.player.onEvent({
            name: 'keyup',
            callback: ({ rawEvent: rawEvent })=>{
                if (rawEvent.code === 'ArrowUp') this.player.stopMove('up');
                if (rawEvent.code === 'ArrowDown') this.player.stopMove('down');
            }
        });
    }
    _setupMachinePlayerAI() {
        this.machineAI = new (0, $dd536d7a2f7bfeb0$export$d4c35b16058796c2)({
            pongBall: this.ball,
            playerObject: this.machine
        });
    }
}


class $0c18a7f317bc0346$export$9d77edc3ea5bdacc {
    _audioCtx = new AudioContext();
    _loadedAudios = {};
    async loadSound({ id: id, url: url }) {
        if (this._loadedAudios[id]) return;
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'audio/mp3'
            },
            method: 'GET'
        });
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await this._audioCtx.decodeAudioData(arrayBuffer);
        this._loadedAudios[id] = audioBuffer;
    }
    async playSound({ id: id, loop: loop = false, gain: gain = 1 }) {
        const audioBufferSource = this._audioCtx.createBufferSource();
        const gainNode = this._audioCtx.createGain();
        audioBufferSource.buffer = this._loadedAudios[id];
        gainNode.gain.value = gain;
        audioBufferSource.loop = loop;
        audioBufferSource.connect(gainNode);
        gainNode.connect(this._audioCtx.destination);
        audioBufferSource.start(0);
    }
}


var $ff39c04b9211165a$exports = {};
$ff39c04b9211165a$exports = import.meta.resolve("5HclQ");


var $34a3ed559dac494a$exports = {};
$34a3ed559dac494a$exports = import.meta.resolve("gvkyG");


var $e5130bf0c22ed8f4$exports = {};
$e5130bf0c22ed8f4$exports = import.meta.resolve("20oyl");


var $e4552e35fed4619c$exports = {};
$e4552e35fed4619c$exports = import.meta.resolve("hCADN");


const $9de921df404b4544$var$allSoundsUrls = [
    {
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ff39c04b9211165a$exports))),
        id: 'background'
    },
    {
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e5130bf0c22ed8f4$exports))),
        id: 'hit1'
    },
    {
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e4552e35fed4619c$exports))),
        id: 'hit2'
    },
    {
        url: (0, (/*@__PURE__*/$parcel$interopDefault($34a3ed559dac494a$exports))),
        id: 'coin'
    }
];
class $9de921df404b4544$export$203b3d13b9633716 {
    Sound = new (0, $0c18a7f317bc0346$export$9d77edc3ea5bdacc)();
    bgSoundIsPlaying = false;
    async loadAllSounds() {
        return Promise.all($9de921df404b4544$var$allSoundsUrls.map(async ({ url: url, id: id })=>{
            await this.Sound.loadSound({
                url: url,
                id: id
            });
        }));
    }
    playBackgroundSound() {
        if (!this._bgSoundIsPlaying) {
            this.Sound.playSound({
                id: 'background',
                loop: true,
                gain: 0.35
            });
            this._bgSoundIsPlaying = true;
        }
    }
    playUserHitPlaySound() {
        this.Sound.playSound({
            id: 'hit1',
            gain: 3
        });
    }
    playMachineHitPlaySound() {
        this.Sound.playSound({
            id: 'hit2',
            gain: 3
        });
    }
    playScoreSound() {
        this.Sound.playSound({
            id: 'coin',
            gain: 5
        });
    }
}




class $c4a9c864c61e8494$export$2451d3eac7062830 {
    title = new (0, $59bb41db2b03bda2$export$5f986618f9ed165)({
        name: 'game-title',
        text: 'PONG',
        fontSize: 144,
        fontColor: (0, $037a87e36871af8f$export$56d196d2844d1ca1).HIGHLIGHT
    });
    startBtn = new (0, $59bb41db2b03bda2$export$5f986618f9ed165)({
        name: 'game-start-button',
        text: 'start',
        fontSize: 36,
        fontColor: (0, $037a87e36871af8f$export$56d196d2844d1ca1).LIGHT
    });
    _onStart = ()=>{
        throw new Error('No callback given to onClickStart');
    };
    onClickStart(callback) {
        this._onStart = callback;
    }
    show() {
        const titleMarginLeft = 165;
        const titleMarginTop = 194;
        const startBtnMarginTop = 325;
        const startBtnMarginLeft = 330;
        this.title.setCoordinates({
            x: titleMarginLeft,
            y: titleMarginTop
        });
        this.startBtn.setCoordinates({
            x: startBtnMarginLeft,
            y: startBtnMarginTop
        });
        this.startBtn.setSizes({
            width: 150,
            height: 30
        });
        this._setupEvents();
    }
    getScreenGameObjects() {
        return [
            this.title,
            this.startBtn
        ];
    }
    _setupEvents() {
        this.startBtn.onEvent({
            name: 'mousemove',
            callback: ({ isInsideGameObjectArea: isInsideGameObjectArea })=>{
                if (isInsideGameObjectArea) this.startBtn.fontColor = (0, $037a87e36871af8f$export$56d196d2844d1ca1).HIGHLIGHT;
                else this.startBtn.fontColor = (0, $037a87e36871af8f$export$56d196d2844d1ca1).LIGHT;
            }
        });
        this.startBtn.onEvent({
            name: 'click',
            callback: ({ isInsideGameObjectArea: isInsideGameObjectArea })=>{
                if (isInsideGameObjectArea) this._onStart();
            }
        });
    }
}


class $a3139df46f527d7c$export$ae9351dbe5ffe2ee {
    DOM = {};
    onDOMIsReadyCallbackList = [];
    init({ gameCanvas: gameCanvas }) {
        this._setupDOM();
        window.onload = ()=>{
            this._appendCanvasToDOM({
                gameCanvas: gameCanvas
            });
            this._runOnDOMIsReadyCallbacks();
        };
    }
    onDOMIsReady(callback) {
        this.onDOMIsReadyCallbackList.push(callback);
    }
    _setupDOM() {
        this.DOM.canvasPlaceholder = document.querySelector('#canvas-placeholder');
    }
    _appendCanvasToDOM({ gameCanvas: gameCanvas }) {
        this.DOM.canvasPlaceholder.appendChild(gameCanvas);
    }
    _runOnDOMIsReadyCallbacks() {
        this.onDOMIsReadyCallbackList.forEach((callback)=>{
            callback();
        });
    }
}


class $ad10e242141a7b3c$export$63a9d7375ad7e9a {
    Canvas = new (0, $9ebc86e59e467e73$export$c672d870a5fac9b)();
    UX = new (0, $a3139df46f527d7c$export$ae9351dbe5ffe2ee)();
    GameRenderEngine = new (0, $5972a2952a676e7e$export$a00812b7fa77a768)();
    StartScreen = new (0, $c4a9c864c61e8494$export$2451d3eac7062830)();
    MatchScreen = new (0, $2f29cb6e6111d04d$export$54e8baba0a5011af)();
    Sound = new (0, $9de921df404b4544$export$203b3d13b9633716)();
    gameScore = {
        [(0, $037a87e36871af8f$export$96d2c50407ad80f7).USER]: 0,
        [(0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE]: 0
    };
    init() {
        this._setupGame();
        this._setupInitialScreen();
        this._setupUX();
        this.Controller.startGame();
    }
    _setupGame() {
        this.Canvas.setCanvasSize((0, $037a87e36871af8f$export$192d610b0b7719f4).WIDTH, (0, $037a87e36871af8f$export$192d610b0b7719f4).HEIGHT);
        this.Controller = new (0, $124834f2d4b25abd$export$f3f3f6c0124f08de)({
            gameCanvas: this.Canvas,
            renderEngine: this.GameRenderEngine
        });
    }
    _setupInitialScreen() {
        this.StartScreen.getScreenGameObjects().forEach((gameObject)=>{
            this.GameRenderEngine.addGameObject({
                gameObject: gameObject
            });
            gameObject.watchForEvents({
                gameCanvas: this.Canvas.getCanvas()
            });
        });
        this.StartScreen.onClickStart(()=>this._setupMatchScreen());
        this.StartScreen.show();
    }
    _setupMatchScreen() {
        this.StartScreen.getScreenGameObjects().forEach((gameObject)=>{
            this.GameRenderEngine.removeGameObject({
                gameObject: gameObject
            });
        });
        this.MatchScreen.show();
        this.MatchScreen.getScreenGameObjects().forEach((gameObject)=>{
            this.GameRenderEngine.addGameObject({
                gameObject: gameObject
            });
            gameObject.watchForEvents({
                gameCanvas: this.Canvas.getCanvas()
            });
        });
        this.MatchScreen.onPlayerHitsBall(({ playerType: playerType })=>{
            if (playerType === (0, $037a87e36871af8f$export$96d2c50407ad80f7).USER) this.Sound.playUserHitPlaySound();
            if (playerType === (0, $037a87e36871af8f$export$96d2c50407ad80f7).MACHINE) this.Sound.playMachineHitPlaySound();
        });
        this.MatchScreen.onScore(({ playerType: playerType })=>{
            this.gameScore[playerType] = this.gameScore[playerType] + 1;
            this.Sound.playScoreSound();
            this.MatchScreen.updateScore(this.gameScore);
        });
    }
    _setupUX() {
        this.UX.onDOMIsReady(()=>{
            this.Sound.loadAllSounds().then(()=>{
                this.Sound.playBackgroundSound();
            });
        });
        this.UX.init({
            gameCanvas: this.Canvas.getCanvas()
        });
    }
}


const $6d8846bbe1b204fb$var$pongController = new (0, $ad10e242141a7b3c$export$63a9d7375ad7e9a)();
document.addEventListener('DOMContentLoaded', ()=>{
    $6d8846bbe1b204fb$var$pongController.init();
});


//# sourceMappingURL=pong.89ad8fdd.js.map
